import { ConfirmationResponseData, MatchingUuidEmailResponse } from "@/features/register/types";
import { AuthApiClient } from "@/features/user/api-client/api-client";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { MirrorConfirmMutationProps } from "../types";

export default function useConfirmMirrorUuidMutation(
  options?: UseMutationOptions<
    ConfirmationResponseData<MatchingUuidEmailResponse>,
    Error,
    MirrorConfirmMutationProps
  >
) {
  return useMutation<
    ConfirmationResponseData<MatchingUuidEmailResponse>,
    Error,
    MirrorConfirmMutationProps
  >({
    mutationFn: async ({ email, mirror_uuid }) => {
      const response = await AuthApiClient.confirmMirror(email, mirror_uuid);
      return response;
    },
    ...options
  });
}
